/** Shared Farm Type + browser profile catalog (mirrors backend FINGERPRINT_POOL). */

export const FARM_TYPES = [
  { value: 'browser', label: 'Browser' },
  { value: 'mobile', label: 'Mobile' },
];

/** Sticky TLS / HTTP identity profiles used for browser-farm agents. */
export const BROWSER_PROFILES = [
  { value: 'firefox135', label: 'Firefox 135', os: 'windows' },
  { value: 'firefox133', label: 'Firefox 133', os: 'windows' },
  { value: 'chrome131', label: 'Chrome 131', os: 'windows' },
  { value: 'chrome120', label: 'Chrome 120', os: 'windows' },
  { value: 'safari18_0', label: 'Safari 18', os: 'macos' },
  { value: 'chrome_android', label: 'Chrome Android', os: 'android' },
];

export const DEFAULT_BROWSER_PROFILE = 'firefox135';

export function farmTypeLabel(runtime) {
  return runtime === 'mobile' ? 'Mobile' : 'Browser';
}

export function browserProfileLabel(tlsProfile) {
  const hit = BROWSER_PROFILES.find((p) => p.value === tlsProfile);
  return hit?.label || tlsProfile || 'Firefox 135';
}

export function osForProfile(tlsProfile) {
  const hit = BROWSER_PROFILES.find((p) => p.value === tlsProfile);
  return hit?.os || 'windows';
}

export function isValidBrowserProfile(tlsProfile) {
  return BROWSER_PROFILES.some((p) => p.value === tlsProfile);
}
